import React, { useCallback } from "react";

import { IconTypes, NotificationTypes } from "../../../../enums";
import { useTranslation } from "../../../../hooks";
import { Notification } from "../../../../models";

interface NotificationItemProps extends Notification {
  onClose: (id: string) => void;
  onClick?: () => void;
}

export const NotificationItem: React.FC<NotificationItemProps> = ({
  id,
  icon,
  type,
  message,
  onClick,
  onClose,
}) => {
  const t = useTranslation();

  const handleCloseClick = useCallback((e: React.MouseEvent<HTMLButtonElement, MouseEvent>, id: string) => {
    e.stopPropagation();
    onClose(id);
  }, [onClose, id]);

  return (
    <li
      onClick={onClick}
      className={`notification ${type} ${type === NotificationTypes.Error ? "error" : ""}`}
    >
      <i className={icon} />
      <p>{t(message)}</p>
      <button
        type="button"
        onClick={(e) => handleCloseClick(e,id)}
        className={IconTypes.Close}
      />
    </li>
  );
};
